export const cn = (...classes) => classes.filter(Boolean).join(" ");

export const formControlClass = cn(
  "min-h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900",
  "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
  "disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
);

export const formControlTextareaClass = cn(
  formControlClass,
  "min-h-24 resize-none"
);

export const formFieldClass = "space-y-2";
export const formFieldLabelClass = "block text-sm font-medium text-gray-700";
export const formFieldHintClass = "text-xs text-gray-500";
export const formFieldErrorClass = "text-xs font-medium text-red-600";

export const buttonBaseClass = cn(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors",
  "disabled:cursor-not-allowed disabled:opacity-70"
);

export const buttonSizeClasses = {
  sm: "min-h-9 px-3 py-2",
  md: "min-h-10 px-4 py-2",
};

export const buttonVariantClasses = {
  primary: "bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-400",
  secondary: "bg-gray-500 text-white hover:bg-gray-600 disabled:bg-gray-400",
  ghost:
    "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:bg-gray-100",
  outline:
    "border border-blue-600 bg-white text-blue-700 hover:bg-blue-50 disabled:border-gray-300 disabled:bg-gray-100 disabled:text-gray-400",
  segmented: "border-0 shadow-none",
  danger: "bg-red-600 text-white hover:bg-red-700 disabled:bg-gray-400",
  success: "bg-green-600 text-white hover:bg-green-700 disabled:bg-gray-400",
  warning:
    "bg-amber-600 text-white hover:bg-amber-700 disabled:bg-amber-400",
};

export const iconButtonBaseClass = cn(
  "inline-flex items-center justify-center rounded-md transition-colors",
  "disabled:cursor-not-allowed disabled:opacity-50"
);

export const iconButtonSizeClasses = {
  sm: "h-8 w-8 p-1.5",
  md: "h-10 w-10 p-2",
};

export const iconButtonVariantClasses = {
  ghost:
    "border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 disabled:bg-white",
  primary: "bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-400",
  danger: "text-red-600 hover:text-red-900",
  warning: "text-amber-600 hover:text-amber-900",
  success: "text-green-600 hover:text-green-900",
  info: "text-blue-600 hover:text-blue-900",
  neutral: "text-gray-500 hover:text-gray-700",
};

export const checkboxClass =
  "rounded border-gray-300 text-blue-600 focus:ring-blue-500";

export const buttonPageActiveClass = "bg-blue-600 text-white";
export const buttonPageClass =
  "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50";
export const segmentedControlClass =
  "inline-flex rounded-xl border border-gray-200 bg-white p-1";
export const segmentedControlButtonClass = "rounded-lg border-0 shadow-none";
export const segmentedControlButtonInactiveClass =
  "bg-transparent text-gray-700 hover:bg-gray-100";
export const segmentedControlButtonActiveClass =
  "bg-blue-600 text-white hover:bg-blue-600";
